import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { Device, MatchedThermostat } from '../../data/smart-devices.interface';

@Component({
  standalone: false,
  selector: 'sbnb-smart-device-thermostats-table',
  templateUrl: 'smart-device-thermostats-table.component.html',
  styleUrls: ['smart-device-thermostats-table.component.scss'],
})
export class SmartDeviceThermostatsTableComponent {
  isMobile$ = this.deviceDetectionService.isMobileViewport();

  displayedColumns: string[] = ['name', 'properties', 'online', 'current-pre-set', 'current-temperature', 'thermostat-setting', 'fan', 'humidity'];
  @Input() thermostats: MatchedThermostat[] = [];

  @Output() nameClicked: EventEmitter<{ deviceId: string; deviceType: MatchedThermostat['device_type'] }> = new EventEmitter();

  constructor(private deviceDetectionService: DeviceDetectionService) { }

  trackDevice(index: number, device: Device): string {
    return device.id;
  }
}
